// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.AKDammCup',
  title: 'hardCoded.title.flautaAKdamm',
  slug: titleToSlug('hardCoded.title.flautaAKdamm'),
  catalog: {
    title: 'hardCoded.catalog.title.AKDammCup',
    catalogMedia,
    price: numberToCurrency('18'),
    color: '#ffffff'
  }
}
